import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  Popover,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import 'date-fns';
import React, { useState, useEffect } from 'react';
import { CAR_STATUS } from 'src/app/constant/config';
import CarStatusBar from '../maps/CarStatusBar';
import ToolBarMenu from './ToolBarMenu';
import VehicleTableStreaming from './VehicleTableStreaming';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
    width: '100%'
  },
  listInformation: {
    width: '100%',
    maxWidth: 375,
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper
  },
  popoverHeader: {
    textAlign: 'center'
  },
  textInforCar: {
    color: '#0C1132 !important',
    fontSize: '14px !important',
    lineHeight: '19.6px',
    fontWeight: 400,
    padding: '15px 0'
  }
}));

const MenuVideo = ({
  vehiclesCamera4G,
  statisticVehicleStatus,
  getVehicle,
  carStatus,
  setCarStatus,
  fetchData,
  fetchDataByUserId
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [deviceType, setDeviceType] = useState(null);

  const listVehicleTracking = useSelector(
    state => state.vehicleSlice.listVehicleTracking
  );

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const iconInfo = open ? 'notice' : 'notice_gray';
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box
      style={{
        padding: '0 1em',
        width: '384px',
        height: '100%',
        position: 'absolute',
        top: 60,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      <ToolBarMenu
        vehicles={vehiclesCamera4G}
        deviceType={deviceType}
        setDeviceType={setDeviceType}
        fetchData={fetchData}
        fetchDataByUserId={fetchDataByUserId}
      />

      <Box
        style={{
          borderRadius: '5px',
          boxShadow: 'unset'
        }}
      >
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            style={{ color: '#0C1132', font: '16px', fontWeight: 600 }}
          >
            Danh sách thiết bị
          </Typography>
          <Box
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Box
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <span className="list_tracking_action">
                <img alt="icon" src="/static/iconSvg/sync.svg" />{' '}
              </span>
              <span
                className="list_tracking_action"
                aria-describedby={id}
                onClick={handleClick}
              >
                <img alt="icon" src={`/static/iconSvg/${iconInfo}.svg`} />
              </span>
            </Box>

            <Box
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left'
                }}
              >
                <Typography className={classes.typography}>
                  <div className={classes.popoverHeader}>
                    <b> Chú thích </b>
                    <span className="float-right">
                      <img
                        alt="button_close"
                        className="list_tracking_action"
                        onClick={handleClose}
                        width="12px"
                        height="12px"
                        src="/static/iconSvg/close-btn.svg"
                      />
                    </span>
                  </div>

                  <List className={classes.listInformation}>
                    {CAR_STATUS &&
                      CAR_STATUS.map((car, index) => (
                        <>
                          <ListItem>
                            <ListItemAvatar>
                              <img
                                alt="icon"
                                src={`/static/iconSvg/carsv2/${car?.icon}.svg`}
                                className="imageCarInfo"
                              />
                            </ListItemAvatar>
                            <span className={classes.textInforCar}>
                              {car?.info}
                            </span>
                          </ListItem>
                          {CAR_STATUS.length !== index + 1 ? (
                            <Divider variant="inset" component="li" />
                          ) : null}
                        </>
                      ))}
                  </List>
                </Typography>
              </Popover>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        style={{
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          marginTop: '12px'
        }}
      >
        {vehiclesCamera4G.length > 0 ? (
          <VehicleTableStreaming
            getVehicle={getVehicle}
            deviceType={deviceType}
            carStatus={carStatus}
            listVehicle={vehiclesCamera4G}
          />
        ) : (
          <Box
            style={{
              height: '97%',
              border: '1.5px solid #e1e3e6cc',
              borderRadius: '4px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              fontSize: '14px'
            }}
          >
            <img
              src="/static/empty.png"
              class="justify-content-center"
              style={{ width: '200px' }}
            />
            <span> Danh sách trống </span>
          </Box>
        )}
      </Box>

      <Box
        style={{
          width: '100%',
          marginBottom: '80px'
        }}
      >
        <CarStatusBar
          carStatus={carStatus}
          setCarStatus={setCarStatus}
        />

        <Typography
          style={{
            color: '#D9042F',
            fontSize: '14px',
            fontWeight: '500',
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '16px'
          }}
        >
          Tổng số thiết bị: {vehiclesCamera4G.length}/{listVehicleTracking.length}
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(MenuVideo);
